<template lang="pug">
#tabela-dinamica-dashboard-laudos
    el-table(:data='payload.itens', stripe, height='530')
        el-table-column(
            v-for='(coluna, index) in payload.colunas',
            v-if='coluna !== "Id"',
            :key='index',
            :label="$t(`mensagens.laudos.tabelaDinamica.${payload.codigo[index]}`)",
            :prop='Object.keys(payload.itens[0])[index]',
            :min-width='`calc(\'100%\' / ${payload.colunas.length - 2})%`'
        )

        el-table-column(v-if='payload.visualizar', fixed='right', width='50px')
            template(slot-scope='scope')
                i.el-icon-view.icon-view.mudando-cursor(
                    @click='visualizarDadosItem(scope.row)'
                )
</template>

<script>
export default {
    name: 'TabelaDinamicaDashboardLaudos',
    props: {
        payload: {
            type: Object,
            required: true,
            default: () => ({
                colunas: ['dataCadastro', 'nome', 'localidade', 'areaHa'],
                codigo: 'TERRITORIOS_CADASTRADOS',
                itens: [
                    {
                        dataCadastro: 'a',
                        nome: 'b',
                        municipio: 'c',
                        areaHa: 'd',
                        id: 0
                    }
                ],
                visualizar: true
            })
        }
    },
    methods: {
        visualizarDadosItem(itemTabela) {
            switch (this.payload.codigo) {
                case 'TERRITORIOS_CADASTRADOS':
                    this.$router.push({
                        name: 'VisualizarTerritorio',
                        params: { idTerritorio: itemTabela.id }
                    });
                    break;
                case 'OPERACOES_CADASTRADAS':
                    this.$router.push({
                        name: 'operacaoVisualizar',
                        params: { id: itemTabela.id }
                    });
                    break;
                case 'OPERACOES_REPROVADAS':
                    this.$router.push({
                        name: 'operacaoVisualizar',
                        params: { id: itemTabela.id }
                    });
                    break;
                case 'OPERACOES_MONITORADAS':
                    this.$router.push({
                        name: 'operacaoMonitoramento',
                        params: { id: itemTabela.id }
                    });
                    break;
                case 'OPERACOES_ALERTA':
                    this.$router.push({
                        name: 'operacaoMonitoramento',
                        params: { id: itemTabela.id }
                    });
                    break;
                case 'OPERACOES_RELACIONADAS_INIBICAO':
                    this.$router.push({
                        name: 'operacaoVisualizar',
                        params: { id: itemTabela.id }
                    });
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#tabela-dinamica-dashboard-laudos {
    width: 100%;
}

.mudando-cursor {
    cursor: pointer;
}
</style>
